import React from 'react';

import PropTypes from 'prop-types';

import { TapListener } from 'wanderu-utils';

class OutsideClick extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        cancelOutsideClick: PropTypes.bool,
        onOutsideClick: PropTypes.func,
    };

    static defaultProps = {
        className: '',
        cancelOutsideClick: true,
        onOutsideClick() {},
    };

    constructor(props) {
        super(props);
        this._el = undefined;
        this._tapListener = undefined;
    }

    componentDidMount() {
        document.addEventListener('click', this._onClick, true);
        this._tapListener = new TapListener({
            rejectClick: false,
        });
        this._tapListener.addListener(document, this._onTap);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._onClick, true);
        this._tapListener.removeListener();
    }

    _onTap = (e) => {
        this._onClick(e);
    }

    _onClick = (e) => {
        if (this.props.deactivate || this._el.contains(e.target)) {
            return;
        }

        if (this.props.cancelOutsideClick) {
            e.preventDefault();
            e.stopPropagation();
        }

        this.props.onOutsideClick(e);
    }

    render() {
        return (
            <div
                className={this.props.className}
                ref={(node) => this._el = node}
            >
                {this.props.children}
            </div>

        );
    }
}

export default OutsideClick;
